import { render } from "./SuccessPage.vue?vue&type=template&id=50fd48a7&scoped=true"
import script from "./SuccessPage.vue?vue&type=script&lang=js"
export * from "./SuccessPage.vue?vue&type=script&lang=js"

import "./SuccessPage.vue?vue&type=style&index=0&id=50fd48a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50fd48a7"]])

export default __exports__